'use strict';

var markers = [];

// function closeInfowindow(){

// }
function createMap(boutiquesResult, singleBoutique, countryCode) {
    markers = [];
    var iconHover = new BMap.Icon($('#mapBaidu').data('urlmarker'), new BMap.Size(30, 45));
    var map = new BMap.Map(document.getElementById('mapBaidu'));
    var center = new BMap.Point(106.554413, 29.557184);
    map.centerAndZoom(center, 4);
    map.addControl(new BMap.NavigationControl());
    map.addControl(new BMap.ScaleControl());
    map.clearOverlays();
    var infoWindow;
    for (var i = 0; i < boutiquesResult.length; i++) {
        var point = new BMap.Point(boutiquesResult[i].markers.long, boutiquesResult[i].markers.lat);
        var marker = new BMap.Marker(point);
        marker.position = point;
        marker.id = boutiquesResult[i].ID;
        marker.name = boutiquesResult[i].name;
        marker.url = boutiquesResult[i].urlSingleBoutique;
        marker.more = boutiquesResult[i].more;
        marker.city = boutiquesResult[i].city;
        marker.strokeClose = boutiquesResult[i].strokeClose;
        marker.address1 = boutiquesResult[i].address1;
        marker.stateCode = boutiquesResult[i].stateCode;
        marker.postalCode = boutiquesResult[i].postalCode;
        marker.country = boutiquesResult[i].country;
        marker.phone = boutiquesResult[i].phone;
        marker.storeHours = boutiquesResult[i].storeHours;
        marker.boutiqueImage = boutiquesResult[i].boutiqueImage;
        marker.bookAppointmentLink = boutiquesResult[i].bookAppointmentLink || false;
        marker.bookLabel = boutiquesResult[i].bookLabel || false;
        marker.setIcon(iconHover);
        markers.push(marker);
        map.addOverlay(markers[i]);
        // click on marker show infowindow
        markers[i].addEventListener('click', function() {
            infoWindow = new BMap.InfoWindow(infowindowContent(this, false));
            var position = this.position;
            map.openInfoWindow(infoWindow, position);
            var boutiqueId = this.id;
            $('.js-active-search').parent().removeClass('cc-active-live-search');
            $('.js-active-search[data-boutiqueid="' + boutiqueId + '"]').parent().addClass('cc-active-live-search');
        });
    }
}

$(document).on('click', '.js-active-search', function () {
    var boutiqueid = this.dataset.boutiqueid;
    for (var j = 0; j < markers.length; j++) {
        if (markers[j].id === boutiqueid) {
            var infoWindow = new BMap.InfoWindow(infowindowContent(markers[j], false));
            markers[j].openInfoWindow(infoWindow);
        }
    }
});

function createSingleMap(data, singleBoutique, countryCode) {
    var iconHover = new BMap.Icon($('#mapBaidu').data('urlmarker'), new BMap.Size(30, 45));
    var map = new BMap.Map(document.getElementById('mapBaidu'));
    var point = new BMap.Point(data[0].markers.long, data[0].markers.lat);
    var marker = new BMap.Marker(point);
    marker.setIcon(iconHover);
    map.addOverlay(marker);
    marker.addEventListener('click', function() {
        if (!window.isMobile) {
            var infoWindow = new BMap.InfoWindow(infowindowContent(data[0], true));
            map.openInfoWindow(infoWindow, point);
        }
    });
    map.centerAndZoom(point, 8);
    map.addControl(new BMap.NavigationControl());
    map.addControl(new BMap.ScaleControl());
    map.setViewport(marker);
}

function infowindowContent(data, singleBoutique) {
    var closeLabel = $('#js-close-label').val();
    var contentString;
    if (singleBoutique) {
        contentString = '<div class="cc-signle-boutiques-google-markers">' +
            '<div class="cc-single-google-header">' +
            '<h2 class="cc-text-title cc-marker-padding heading-as-span">' + data.city + '</h2>' +
            '<button class="cc-boutiques-close" id="js-close-infowindow" aria-label="'+closeLabel+'">' +
            '<svg class="cc-icon" aria-hidden="true" focusable="false">' +
            '<use xlink:href="' + data.strokeClose + '"></use></svg>' +
            '</button>' +
            '</div>' +
            '<div class="container cc-marker-padding-top">' +
            '<div class="row">' +
            '<div class="col-12 cc-clean-padding">' +
            '<img class="cc-boutiqus-images" src="' + data.boutiqueImage[0] + '" alt="boutiques-pictures">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    }
    if (singleBoutique && window.isTablet) {
        var rightarrow = $('.cc-images-single-boutiques').data('arrowdx');
        var leftarrow = $('.cc-images-single-boutiques').data('arrowsx');
        // va implementato lo slider se la boutique ha più di un immagine
        contentString = '<div class="cc-signle-boutiques-google-markers">' +
            '<div class="cc-single-google-header">' +
            '<h2 class="cc-text-title cc-marker-padding heading-as-span">' + data.city + '</h2>' +
            '<button class="cc-boutiques-close" id="js-close-infowindow" aria-label="'+closeLabel+'">' +
            '<svg class="cc-icon" aria-hidden="true" focusable="false">' +
            '<use xlink:href="' + data.strokeClose + '"></use></svg>' +
            '</button>' +
            '</div>' +
            '<div class="container cc-marker-padding-top">' +
            '<div class="row">' +
            '<div class="col-12 cc-clean-padding">' +
            '<img class="cc-boutiqus-images" src="' + data.boutiqueImage[0] + '" alt="boutiques-pictures">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    }
    if (!singleBoutique && !window.isMobile) {
        var showMore = '<a href="' + data.url + '" class="cc-boutique-link" aria-label="' + data.more + ' ' + (data.sartoriaName || data.city) + '">' + data.more + '</a>';
        var appointmentLink;
        if (data.bookAppointmentLink) {
            appointmentLink = '<a href="' + data.bookAppointmentLink + '" class="cc-boutique-link-right">' + data.bookLabel + '</a>';
        } else {
            appointmentLink = '';
        }
        contentString = '<div class="cc-google-marker">' +
        '<div class="cc-google-header">' +
        '<h2 class="cc-text-title cc-marker-padding heading-as-span">' + data.city + '</h2>' +
        '<button class="cc-boutiques-close" id="js-close-infowindow" aria-label="'+closeLabel+'">' +
        '<svg class="cc-icon" aria-hidden="true" focusable="false">' +
        '<use xlink:href="' + data.strokeClose + '"></use></svg>' +
        '</button>' +
        '</div>' +
        '<div class="cc-marker-padding-top">' +
        '<div class="row">' +
        '<div class="col-12 col-sm-6">' +
        '<div class="cc-content-img">' +
        '<img class="cc-boutiqus-images" src="' + data.boutiqueImage[0] + '" alt="boutiques-pictures">' +
        '</div>' +
        '</div>' +
        '<div class="col-12 col-sm-6 cc-marker-details">' +
        '<p class="cc-text-medium">' + data.address1 + ', ' +
        '<p class="cc-text-medium">' + data.stateCode + ' ' + data.postalCode + ', ' + data.country + '</p>' +
        '<p class="cc-text-phone">' + data.phone + '</p>' +
        '<p class="cc-text-hours">' + data.storeHours + '</p>' + showMore + appointmentLink +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    }
    return contentString;
}

module.exports = {
    createMap: createMap,
    createSingleMap: createSingleMap
};
